$(document).ready(function() {
	$(document).click(function(e) {
		if ($(e.target).is('.menu-btn:not(.collaps)')){
			return;
		}
		else{
			$('nav.nav-cnt').removeClass('collaps');
			
		}
	});
	$(document).click(function(e) {
		
			if ($(e.target).is($('input.search-input'))){	
				//$('.search-cnt').show();
			return;
			}
		else{
			//console.log($('input.search-input')[0]);
		//	console.log(e.target);
			//console.log('not search-input')
			//$('header .search-btn').removeClass('expand');
			//$('.search-cnt').hide();
			
		}
		
	});	
		
	
	
	$('.search-btn').on('click', function() {		;
		$('header .search-btn').toggleClass('expand');		
		if($(this).hasClass('expand')){
			$('.search-cnt').show();
		//	$('.search-cnt').find('input').focus();
		}else{
			$('.search-cnt').hide();
		}
		
	});

	$('.bdy-cnt').on('click', function() {
		//console.log('cody');
		$('header .search-btn').removeClass('expand');	
		$('.search-cnt').hide();
		
	});
	jQuery.getJSON('/products/abyssinian-pure-chill-black.js', function(product) {
  cnsole.log(product);
} );
//	var p=$('#fos p');
//	var divh=$('#fos').height();
//	while ($(p).outerHeight()>divh) {
//	    $(p).text(function (index, text) {
//	        return text.replace(/\W*\s(\S)*$/, '...');
//	    });
//	}
	
});